module.exports = __webpack_public_path__ + "images/wave/feedbacks/ixe.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/wave/feedbacks/ixe.png
// module id = B5yW
// module chunks = 4